// @flow
import { isEmpty } from 'lodash';

const crawlers = [
  'Googlebot',
  'Bingbot',
  'DuckDuckBot',
  'Baiduspider',
  'Slurp',
  'facebot',
  'facebook',
  'oncrawl',
];

const isCrawler = (uaString: ?string) => {
  // Check that the UA string exists, prevents some malicious actors which
  // attempt to hit the site without a UA string, typically scrapers do this.
  return (
    isEmpty(uaString) ||
    crawlers.some(crawler => {
      const needle = (uaString || '').toLowerCase();
      return needle.includes(crawler.toLowerCase());
    })
  );
};

export default isCrawler;
